<template>
<div class="chapter">
<div class="inner_page">
<p class="center-para"><a id="page_i"></a><strong>Outstanding critical praise for<br/>Homer Hickam and <em>The Keeper’s Son</em></strong></p>
<p class="para"> </p>
<p class="para">“A novel of adventure and romance set on this imaginary isle of wild horses, offbeat townsfolk, and the colorful crew of a Coast Guard patrol boat . . . [a] page-turning story of loss, courage, and providence.”</p>
<p class="right-para"><em>—The Wall Street Journal</em></p>
<p class="para"> </p>
<p class="para">“Well-crafted characters, gripping naval warfare, and colorful island life come together in this dynamic and exciting tale.”</p>
<p class="right-para">—<em>Publishers Weekly</em></p>
<p class="para"> </p>
<p class="para">“Hickam brings it all off flawlessly . . . making the reader believe extraordinary events are indeed possible.”</p>
<p class="right-para"><em>—Roanoke Times</em></p>
<p class="para"> </p>
<p class="para">“[An] irresistibly romantic WWII adventure . . . certain to seduce armchair sailors.”</p>
<p class="right-para">—<em>Kirkus Reviews</em></p>
<p class="para"> </p>
<p class="para">“In this excellent story of World War II on the Outer Banks, Hickam deftly crafts a romantic, even melodramatic story . . . the pacing, the building of character with carefully chosen detail, and the masterful construction of a setting . . . evokes with great skill a time and a place that is passing out of living memory.”</p>
<p class="right-para">—<em>Booklist</em></p>
<p class="para"> </p>
<p class="para">“With this book, Hickam expands his range . . . into the realm of fiction in a compelling novel of war, romance, haunting guilt, victory. Thrilling.”</p>
<p class="right-para">—Robert Morgan, bestselling author of<br/><em>Gap Creek</em> and <em>Brave Enemies</em></p>
<p class="para"> </p>
<p class="para">“Hickam’s recollections of small-town America . . . are so cinematic that even those of us who didn’t grow up there imagine we did.”</p>
<p class="right-para"><em>—The Philadelphia Inquirer</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?5a14c54a